import { apiCall } from '../../../../services/apiUtil';

export const pickleballTournamentStatsAPI = {
  getTournamentStats: async (tournamentId) => {
    return apiCall(`/tournaments/${tournamentId}/stats/pickleball`);
  }
};
